export default "__VITE_ASSET__CA_3Nwh___"